module.exports = __webpack_public_path__ + "static/media/corona-confirmed.c556a4c9.webp";